import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import DatePicker from 'react-datepicker';

import INCSUBUserPaymentDetailCard from '../../../components/userPayment/UserPaymentDetailCard';
import INCSUBButton from '../../../components/common/Button/INCSUBButton';

import {
    updatePoolJoinRequest,
} from '../../../services/userPaymentServices';
import {
    setSelectedPayment,
    setUserPaymentList,
} from '../../../features/userPayments/userPaymentSlice';

import './styleUserPaymentDetails.css';

function INCSUBUserPaymentDetails({ info }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const selectedPayment = useSelector((state) => state.userPayment.selectedPayment);
    const txnReqList = useSelector((state) => state.userPayment.userPaymentList);

    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isDateEmpty, setIsDateEmpty] = useState(false);
    const [reason, setReason] = useState('');
    const [isReasonEmpty, setIsReasonEmpty] = useState(false);

    const [updateTxnData, setUpdateTxnData] = useState({
        poolJoinRequestId: selectedPayment?.poolJoinRequestId || '',
        requestStatus: '',
        transactionDate: '',
        requestActionMessage: '',
    });

    const formatDateTime = (dateTime) => {
        try {
            const date = new Date(dateTime);
            const formattedDate = date.toISOString().slice(0, 10); // YYYY-MM-DD
            const time = date.toTimeString().slice(0, 8); // HH:MM:SS
            return `${formattedDate} ${time}`;
        } catch {
            toast.error('Date format is incorrect.');
            return '';
        }
    };

    const parseCustomDate = (dateString) => {
        try {
            const [datePart, timePart] = dateString.split(' ');
            const [year, month, day] = datePart.split('-').map(Number);
            const [hour, minute] = timePart.split(':').map(Number);
            return new Date(year, month - 1, day, hour, minute);
        } catch {
            toast.error('Date format is incorrect.');
            return null;
        }
    };

    const handleUpdatePayment = async (data) => {

        setIsLoading(true);

        try {
            const response = await updatePoolJoinRequest(data);

            if (response.status === 200) {
                // Update selected payment
                dispatch(setSelectedPayment({
                    ...selectedPayment,
                    requestStatus: data.requestStatus,
                }));


                if (updateTxnData.requestStatus === 'Rejected') {
                    const updatedList = txnReqList.requestList.map((item) =>
                        item.poolJoinRequestId === selectedPayment.poolJoinRequestId
                            ? { ...item, requestStatus: 'Rejected' }
                            : item
                    );
                    dispatch(setUserPaymentList({
                        ...txnReqList,
                        requestList: updatedList,
                    }));
                      console.log(selectedPayment)
                      console.log(updatedList)
                } else {
                    const updatedList = txnReqList.requestList.filter(
                        (item) => item.poolJoinRequestId !== selectedPayment.poolJoinRequestId
                    );
                    dispatch(setUserPaymentList({
                        ...txnReqList,
                        requestList: updatedList,
                    }));
                    console.log(selectedPayment)
                    console.log(updatedList)
                }
                setIsPopupOpen(false);
            } else if (response.status === 401) {
                navigate('/login');
            } else {
                toast.error(`Error: ${response.status}`);
            }
        } catch (err) {
            toast.error('Something went wrong while updating payment.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleVerify = () => {
        if (!updateTxnData.transactionDate) {
            setIsDateEmpty(true);
            return;
        }

        setUpdateTxnData((prev) => ({
            ...prev,
            requestStatus: 'Verified',
        }));
        handleUpdatePayment({
            ...updateTxnData,
            requestStatus: 'Verified',
        });
    };

    const handleReject = () => {
        setIsPopupOpen(true);
    };

    const handleRejectionSubmit = () => {
        if (!reason.trim()) {
            setIsReasonEmpty(true);
            return;
        }

        setUpdateTxnData((prev) => ({
            ...prev,
            requestStatus: 'Rejected',
            requestActionMessage: reason,
        }));

        handleUpdatePayment({
            ...updateTxnData,
            requestStatus: 'Rejected',
            requestActionMessage: reason,
        });
    };

    return (
        <>
            {!isLoading ? (
                <div className="INCSUBPoolVerificationDetails">
                    <INCSUBUserPaymentDetailCard info={info} />

                    <div className="INCSUBPoolVerificationPoolDetailsVerify">
                        <div className="INCSUBPoolVerificationPoolDetailsVerify_ctn">
                            <div className="INCSUBPaymentVerification_image_container">
                                <img src={selectedPayment?.paymentReceiptImage} alt="receipt" />
                            </div>
                        </div>

                        {(selectedPayment?.requestStatus !== 'Rejected' && selectedPayment?.requestStatus !== "Verified") && (
                            <div className="INCSUBPoolMemberDetail_ctn_right">
                                <div className="INCSUBAddCustomTransaction_amount_div paymentVerification">
                                    <div className="INCSUBAddCustomTransaction_amount_heading">*Date</div>
                                    <DatePicker
                                        placeholderText="DD MM YYYY 00:00am"
                                        selected={
                                            updateTxnData.transactionDate
                                                ? parseCustomDate(updateTxnData.transactionDate)
                                                : null
                                        }
                                        onChange={(date) => {
                                            const formatted = formatDateTime(date);
                                            setUpdateTxnData((prev) => ({
                                                ...prev,
                                                transactionDate: formatted,
                                            }));
                                            setIsDateEmpty(false);
                                        }}
                                        timeInputLabel="Time:"
                                        dateFormat="dd-MM-yyyy h:mm aa"
                                        showTimeInput
                                        maxDate={new Date()}
                                        showIcon
                                        className={isDateEmpty ? 'error' : ''}
                                    />
                                </div>

                                <div className="INCSUBUserPayment_button_container">
                                    <INCSUBButton text="Accept" clickFun={handleVerify} />
                                    <INCSUBButton
                                        text="Decline"
                                        clickFun={handleReject}
                                        color="#000000"
                                        background="#2022240A"
                                        border="0.6px solid #2022241A"
                                    />
                                </div>
                            </div>
                        )}
                    </div>

                    {isPopupOpen && (
                        <div className="INCSUBCategory_permission_popup">
                            <div className="INCSUBCategory_ask_container">
                                <div className="INCSUBCategory_permission_header">
                                    Please enter a reason for declining the pool join request.
                                </div>
                                <input
                                    type="text"
                                    placeholder="Type Here..."
                                    value={reason}
                                    onChange={(e) => {
                                        setReason(e.target.value);
                                        setIsReasonEmpty(false);
                                    }}
                                    style={{
                                        border: isReasonEmpty ? '1px solid red' : undefined,
                                    }}
                                />
                                <div className="INCSUBCategory_permission_btn_container">
                                    <div className="INCSUBCategory_image_upload_btn">
                                        <div className="INCSUBCategory_upload_btn" onClick={handleRejectionSubmit}>
                                            Submit
                                        </div>
                                        <div className="upload_cancel_btn" onClick={() => setIsPopupOpen(false)}>
                                            Cancel
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="verification_details_shimmer">
                    <div className="verification_loader" />
                </div>
            )}
        </>
    );
}

export default INCSUBUserPaymentDetails;
